var _style, _polygon, _polygon2, _path, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAjAzul(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Colores",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#39AFE5;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "L\\xEDnea",
    className: "st0",
    points: "34,287.27 153.37,287.09 174.16,255.41 55.27,255.59 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Letra_A",
    className: "st0",
    points: "167.52,88.53 260.55,228.05 260.55,311.55 169.03,174.31 121.09,242.93 63.71,242.93 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Letra_J1",
    className: "st1",
    d: "M260.55,255.59h31.72c0.34,0.03,5.1,0.31,7.93-3.24c1.97-2.48,1.73-5.24,1.65-5.92 c-0.02-39.33-0.05-78.66-0.07-117.98c0.09-0.36,0.17-3.06-2.29-5.79c-1.86-2.07-4.26-2.69-7.04-2.99 c-10.18,0.12-20.36,0.24-30.54,0.37L240.15,88h102.7l0.13,177.77c0.08,1.66,0.15,7.76-4.45,13.46c-4.39,5.44-10.24,7.06-12,7.49 c-21.99,0.19-43.98,0.37-65.98,0.56V255.59z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Letra_J2",
    className: "st1",
    points: "188.9,287.28 244.36,287.27 223.23,255.59 210.79,255.59 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAjAzul);
export default __webpack_public_path__ + "static/media/Logo_AJ_azul.7db5eed413ebf7429a8f840f6a116f30.svg";
export { ForwardRef as ReactComponent };